import { searchAlgolia } from "utils";
import { getFallbackLocale } from "utils/locale";

const getRegions = (countryID) =>
  searchAlgolia("Region", null, {
    restrictSearchableAttributes: `translations.${getFallbackLocale()}`,
    facets: "country_id",
    filters: `country_id:${countryID}`,
    hitsPerPage: 100,
  }).then((regions) => ({
    regions: regions.map((region) => ({
      id: region.id,
      code: region.region_code,
      name: region.translations[getFallbackLocale()],
    })),
  }));

export default getRegions;
